import React, { useEffect, useState } from "react";
import { ApiService } from "../../Axios/ApiService";
import $ from "jquery";
export const ShoppingCartContext = React.createContext();

const ShoppingCartProvider = props => {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [totals, setTotals] = useState({});
    const [productAdded, setProductAdded] = useState(false)
    useEffect(() => {
        getInitialProducts();
        if(props.productAdded && props.productAdded !== ''){
            setProductAdded(props.productAdded)
        }
    }, []);

    const getCartTotals = products => {
        let totals = {
            ex: 0,
            tax: 0,
            in: 0
        };

        products.forEach(p => {
            totals.ex = totals.ex + p.price;
            totals.tax = totals.tax + (p.price / 100 * p.taxValue);
        });
        totals.in = totals.ex + totals.tax;
        setTotals(totals);
    };

    const getInitialProducts = () => {
        try {
            const cartItems = JSON.parse(props.cartItems);
            const cartTotals = JSON.parse(props.cartTotals);
            if (props.productImages) {
                var productImages = JSON.parse(props.productImages);
            }

            let products = [];
            for (let key in cartItems) {
                products.push({
                    ...cartItems[key],
                    hash: key,
                    taxValue: cartTotals[key].tax.value
                });
            }
            if (productImages) {
                products = products.map(p => {
                    return {
                        ...p,
                        image: productImages[p.conditions.variation_id]
                    };
                });
            }

            setProducts(products);
            getCartTotals(products);
        } catch (e) {
            console.log(e);
            throw e
        }
    };

    const onCopyProduct = async hash => {
        try {
            setLoading(true);
            const toCopyProduct = products.find(p => p.hash === hash);
            const res = await ApiService.post("/addtocart", {
                variation_id: toCopyProduct.conditions.variation_id,
                quantity: toCopyProduct.quantity,
                delivery: toCopyProduct.conditions.delivery_id,
                sku: toCopyProduct.conditions.sku,
                verspreidatum: toCopyProduct.attributes.verspreiddatum
            });
            const newHash = res.data;
            setLoading(false);
            setProducts([
                ...products,
                {
                    ...toCopyProduct,
                    hash: newHash,
                    id: newHash
                }
            ]);
            getCartTotals([
                ...products,
                {
                    ...toCopyProduct,
                    hash: newHash,
                    id: newHash
                }
            ]);
            let count = $(".SELECTE_CART_COUNTER").html();
            count = Number(count) + 1;
            $(".SELECTE_CART_COUNTER").html(count);
        } catch (e) {
            console.log(e);
            throw e
        }
    };

    const onDeleteProduct = async hash => {
        try {
            setLoading(true);
            const newProducts = products.filter(p => p.hash !== hash);
            const res = await ApiService.delete(`/removefromcart/${hash}`);
            setLoading(false);
            setProducts(newProducts);
            getCartTotals(newProducts);
            let count = $(".SELECTE_CART_COUNTER").html();
            count = Number(count) - 1;
            $(".SELECTE_CART_COUNTER").html(count);
        } catch (e) {
            console.log(e);
            throw e
        }
    };

    const onRemoveExtraCost = async hash => {
        try {
            setLoading(true);
            const res = await ApiService.post(`/removeextracosts/${hash}`);
            const productUpdated = res.data.data;
            const newProducts = products.map(
                p => {
                    if(p.hash === hash){
                        return {
                            ...p,
                            price: productUpdated.price,
                            attributes: productUpdated.attributes
                        }
                    }
                    else{
                        return p
                    }
                }
            )

            setLoading(false);
            setProducts(newProducts);
            getCartTotals(newProducts);
        } catch (e) {
            console.log(e);
            throw e
        }
    };

    const onChangeQty = async (qty, delivery_id, variation_id, product) => {
        try {
            setLoading(true);
            const res = await ApiService.post(`/update-cart-qty`, {
                variation_id,
                qty,
                delivery_id,
                hash: product.hash,
                sku: product.conditions.sku
            });
            const price = res.data
            const newProducts = products.map(
                p => {
                    if(p.id === product.id){
                        return {
                            ...p,
                            price: price,
                            quantity: qty
                        }
                    }
                    else{
                        return p
                    }
                }
            )
            setProducts(newProducts)
            getCartTotals(newProducts)
            setLoading(false);


        } catch (e) {
            console.log(e);
            throw e
        }
    };

    const value = {
        products,
        onCopyProduct,
        loading,
        onDeleteProduct,
        onRemoveExtraCost,
        totals,
        onChangeQty,
        productAdded,
        paymentOptions: JSON.parse(props.paymentOptions)
    };
    return (
        <ShoppingCartContext.Provider value={value}>
            {props.children}
        </ShoppingCartContext.Provider>
    );
};

export default ShoppingCartProvider;
